import { render, staticRenderFns } from "./MetadataBox.vue?vue&type=template&id=59a1d566&"
import script from "./MetadataBox.vue?vue&type=script&lang=js&"
export * from "./MetadataBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports